import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { BRAND, NAV, wa } from "@/lib/site";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.5 3c.3 2.1 1.6 3.6 3.7 3.9v2.5c-1.3.1-2.5-.3-3.7-1v6.1c0 3.4-2.6 5.8-5.9 5.5-2.7-.2-4.8-2.5-4.7-5.2.1-2.7 2.4-4.8 5.1-4.7.3 0 .6 0 .9.1v2.6c-.3-.1-.6-.2-.9-.2-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2 2.2-1 2.2-2.2V3h3.3z" />
  </svg>
);

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-navy text-white" data-testid="site-footer">
      <div className="relative z-10 mx-auto grid max-w-7xl gap-12 px-6 py-20 md:grid-cols-12 md:px-12 md:py-28">
        {/* Brand */}
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt="HATTORY KONVEKSI" className="h-10 w-10 rounded-lg bg-white p-1 object-contain" />
            <span className="text-2xl font-black tracking-tight">HATTORY</span>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-silver">
            Konveksi custom modern yang mengutamakan kualitas, kecepatan pelayanan,
            dan sistem produksi yang terstruktur. {BRAND.tagline}
          </p>
          <div className="mt-6 flex items-center gap-4">
            <a href={BRAND.socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="rounded-full border border-white/15 p-2.5 text-silver transition-colors hover:border-white hover:text-white"><Instagram className="h-4 w-4" /></a>
            <a href={BRAND.socials.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="rounded-full border border-white/15 p-2.5 text-silver transition-colors hover:border-white hover:text-white"><TikTokIcon className="h-4 w-4" /></a>
            <a href={BRAND.socials.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="rounded-full border border-white/15 p-2.5 text-silver transition-colors hover:border-white hover:text-white"><Facebook className="h-4 w-4" /></a>
          </div>
        </div>

        {/* Navigation */}
        <div className="md:col-span-3">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-silver">Navigasi</h4>
          <ul className="mt-5 space-y-3">
            {NAV.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="text-sm text-white/80 transition-colors hover:text-white" data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="md:col-span-4">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-silver">Hubungi Kami</h4>
          <ul className="mt-5 space-y-4 text-sm text-white/80">
            <li>
              <a href={wa("Halo HATTORY KONVEKSI, saya ingin bertanya seputar layanan Anda.")} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 transition-colors hover:text-white" data-testid="footer-wa">
                <Phone className="mt-0.5 h-4 w-4 shrink-0" /> {BRAND.phone} (WhatsApp)
              </a>
            </li>
            <li>
              <a href={`mailto:${BRAND.email}`} className="flex items-start gap-3 transition-colors hover:text-white">
                <Mail className="mt-0.5 h-4 w-4 shrink-0" /> {BRAND.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0" /> {BRAND.address}
            </li>
          </ul>
        </div>
      </div>

      {/* Kinetic oversized brand text */}
      <div className="pointer-events-none select-none px-6 md:px-12">
        <div className="whitespace-nowrap text-[18vw] font-black leading-none tracking-tighter text-white/[0.04]">
          HATTORY KONVEKSI
        </div>
      </div>

      <div className="relative z-10 border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-6 text-xs text-silver md:flex-row md:px-12">
          <p>© {new Date().getFullYear()} {BRAND.name}. Seluruh hak cipta dilindungi.</p>
          <p>{BRAND.website}</p>
        </div>
      </div>
    </footer>
  );
}
